export default [
  {
    id: 1, 
    dueDate: "Fri, Jan 24, 2025",         
    description: "Annual Starter Invoices",    
    status: "Unpaid",   
    seats: "05", 
    invoiceTotal: '$ 21.00', 
    createdOn:'Fri, Jan 24, 2025', 
    invoiceNumber:'INV1001',
    description2:'Set up two-step verification and single sign-on options for enhanced security.', 
    transaction:'$15.00', 
    amount:"$15.00"
  },
  {
    id: 2, 
    dueDate: "Sat, Jan 25, 2025",         
    description: "Annual Starter Invoices",    
    status: "Paid",   
    seats: "06", 
    invoiceTotal: '$ 22.00',
    createdOn:'Fri, Jan 24, 2025',
    invoiceNumber:'INV1002', 
    description2:'Set up two-step verification and single sign-on options for enhanced security.', 
    transaction:'$15.00', 
    amount:"$15.00"
  },
  {
    id: 3, 
    dueDate: "Sun, Jan 26, 2025",         
    description: "Annual Starter Invoices",    
    status: "Unpaid",   
    seats: "07", 
    invoiceTotal: '$ 23.00',
    createdOn:'Fri, Jan 24, 2025',
    invoiceNumber:'INV1003',
    description2:'Set up two-step verification and single sign-on options for enhanced security.', 
    transaction:'$15.00', 
    amount:"$15.00"
  }, 
   
   
];
